module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment_list"
  }, [_c('div', {
    staticClass: "comment_top"
  }, [_c('div', {
    staticClass: "c_top_left"
  }, [_c('img', {
    attrs: {
      "src": _vm.comment.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.comment.author.loginname))]), _vm._v("3分钟前\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c_top_right"
  }, [_c('i', {
    staticClass: "cnode-iconfont",
    on: {
      "click": _vm.doGood
    }
  }, [_vm._v("\n          "), _c('span', [_vm._v(_vm._s(_vm.comment.ups.length))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment_bottom"
  }, [_c('div', {
    staticClass: "commet_detail markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n          "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-083ee708"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/comment_item.vue
// module id = 133
// module chunks = 1